var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "el-dialog",
        {
          staticClass:
            "popupContainer asl-flex flex-vertical main-center cross-center",
          attrs: {
            visible: _vm.visible,
            fullscreen: true,
            "modal-append-to-body": true,
            "append-to-body": true,
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            title: _vm.showTypesModal
              ? "选择需求类型"
              : "请预留您的联系方式及需求信息",
            center: true,
          },
        },
        [
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("提 交")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "indicator-sub-title as-flex main-center cross-center f-2 fc-gray-2",
            },
            [_vm._v("众观智影为您提供精准的定制数据服务")]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            { ref: "form", attrs: { "label-width": "80px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "联系方式" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.mobile,
                      callback: function ($$v) {
                        _vm.mobile = $$v
                      },
                      expression: "mobile",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "公司名称" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.company,
                      callback: function ($$v) {
                        _vm.company = $$v
                      },
                      expression: "company",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "影片名" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.movie,
                      callback: function ($$v) {
                        _vm.movie = $$v
                      },
                      expression: "movie",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "需求类型" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.chosenTypes,
                        callback: function ($$v) {
                          _vm.chosenTypes = $$v
                        },
                        expression: "chosenTypes",
                      },
                    },
                    [
                      _vm._l(
                        _vm.typesMapping ? _vm.typesMapping.before.data : [],
                        function (item, index) {
                          return [
                            _c(
                              "el-popover",
                              {
                                key: "before_" + index,
                                staticClass: "checkbox-container",
                                attrs: {
                                  "open-delay": 500,
                                  placement: "bottom",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.desc))]),
                                _vm._v(" "),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      label: item.id,
                                      val: "",
                                      name: "type",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                      _vm._v(" "),
                      _vm._l(
                        _vm.typesMapping ? _vm.typesMapping.after.data : [],
                        function (item, index) {
                          return [
                            _c(
                              "el-popover",
                              {
                                key: "after" + index,
                                staticClass: "checkbox-container",
                                attrs: {
                                  "open-delay": 500,
                                  placement: "bottom",
                                  trigger: "hover",
                                },
                              },
                              [
                                _c("span", [_vm._v(_vm._s(item.desc))]),
                                _vm._v(" "),
                                _c(
                                  "el-checkbox",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      label: item.id,
                                      val: "",
                                      name: "type",
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ],
                              1
                            ),
                          ]
                        }
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "补充说明" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea", rows: 5 },
                    model: {
                      value: _vm.questionDetail,
                      callback: function ($$v) {
                        _vm.questionDetail = $$v
                      },
                      expression: "questionDetail",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "error as-flex main-start cross-center f-1" },
            [_vm._v(_vm._s(_vm.error.msg))]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }